import { stageOf } from 'assets/data/estadosPresupuesto';
import { primaryActionFor } from 'assets/data/accionesPresupuesto';

// Etapas desde las que se puede re-cotizar (crear una versión nueva editable).
// `aprobado` es terminal. Debe coincidir con el guard del backend.
export const VERSIONABLE_STAGES = ['esperando_aprobar', 'en_espera', 'rechazado'];

// Etapas en las que el presupuesto ya tiene una ODT (y por lo tanto carta Gantt).
const STAGES_WITH_ODT = ['odt_no_asignada', 'odt_asignada', 'odt_en_proceso', 'finalizada'];

const DEFAULT_STAGE = 'esperando_aprobar';

const item = (key, label, extra) => ({ key, label, ...extra });

// Ítems de menú propios de la etapa (van antes de los comunes).
const STAGE_MENU = {
  esperando_aprobar: [item('reject', 'Rechazar')],
  odt_asignada: [item('openOdtForm', 'Editar ODT')],
  finalizada: [item('openOdtStatus', 'Ver estado')],
};

/**
 * Qué acciones muestra una fila de la tabla de presupuestos.
 *
 * Función pura: una sola acción principal por etapa (`primary`, o null) y el resto
 * en el menú "…" (`menu`), con la principal nunca repetida. El orden del menú es:
 * acciones de la etapa, carta Gantt (si hay ODT), y los ítems comunes
 * (editar, nueva versión / re-cotizar, historial, eliminar).
 *
 * @param {object} record fila de la lista: { stage, revision, expired, superseded, ... }
 * @returns {{ primary: {key,label,tone}|null, menu: Array<{key,label,danger?}> }}
 */
export function buildRowActions(record) {
  const stage = stageOf(record) ?? DEFAULT_STAGE;
  const primary = primaryActionFor(stage);

  const menu = [...(STAGE_MENU[stage] ?? [])];

  if (STAGES_WITH_ODT.includes(stage)) {
    menu.push(item('openGantt', 'Carta Gantt'));
  }

  menu.push(item('edit', 'Editar'));

  if (VERSIONABLE_STAGES.includes(stage) && !record.superseded) {
    const label = record.expired || stage === 'rechazado' ? 'Re-cotizar' : 'Nueva versión';
    menu.push(item('reversion', label));
  }

  if ((record.revision ?? 1) > 1 || record.superseded) {
    menu.push(item('history', 'Historial de versiones'));
  }

  menu.push(item('delete', 'Eliminar', { danger: true }));

  return { primary, menu };
}
